import React from 'react'
import { string } from 'prop-types'
import styled from 'styled-components'
import IcoCard from '../icons/IcoCard'
import { theme } from '../../styles'

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  height: 21px;
  color: ${theme.cores.inkSoft};

  svg {
    display: block;
    border-radius: 3px;
  }
`

const TextMark = styled.span`
  display: inline-flex;
  align-items: center;
  height: 21px;
  padding: 0 7px;
  border-radius: 4px;
  font-family: ${theme.fontes.sans};
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  background: ${( { $bg } ) => $bg};
  color: ${( { $fg } ) => $fg};
`

const BRANDS = {
  'AMEX': { 'bg': '#006FCF', 'fg': '#FFFFFF', 'label': 'AMEX' },
  'ELO': { 'bg': '#000000', 'fg': '#FFFFFF', 'label': 'ELO' },
  'HIPERCARD': { 'bg': '#B3131B', 'fg': '#FFFFFF', 'label': 'HIPER' },
  'VISA': { 'bg': '#1A1F71', 'fg': '#FFFFFF', 'label': 'VISA' }
}

export default function BrandMark( { brand } ) {
  const chave = String( brand || '' ).trim()
    .toUpperCase()

  if ( chave === 'MASTERCARD' ) {
    return (
      <Wrap aria-label="Mastercard">
        <svg
          height="21"
          role="img"
          viewBox="0 0 40 24"
          width="34"
        >
          <circle
            cx="15"
            cy="12"
            fill="#EB001B"
            r="8"
          />
          <circle
            cx="25"
            cy="12"
            fill="#F79E1B"
            r="8"
          />
          <path
            d="M20 5.6a8 8 0 0 0 0 12.8 8 8 0 0 0 0-12.8z"
            fill="#FF5F00"
          />
        </svg>
      </Wrap>
    )
  }

  const marca = BRANDS[ chave ]

  if ( !marca ) {
    return (
      <Wrap aria-label="Cartão">
        <IcoCard
          height="18"
          width="18"
        />
      </Wrap>
    )
  }

  return (
    <TextMark
      $bg={ marca.bg }
      $fg={ marca.fg }
      aria-label={ marca.label }
    >
      { marca.label }
    </TextMark>
  )
}

BrandMark.propTypes = {
  'brand': string
}

BrandMark.defaultProps = {
  'brand': ''
}
